<template>
  <div>
    <HeadersDetalhesResumo
      :apelido="imovel.apelido"
      :proprietario="imovel.proprietario"
      :tipo="imovel.tipo"
    >
    </HeadersDetalhesResumo>
    <v-layout row wrap align-center class="secondary white--text detalhes-header">
      <v-flex xs2>
        <v-container fluid class="py-2">      
          <v-layout row wrap>
            <v-flex xs12 class="text-xs-left">
              <v-btn icon :to="({ name: 'ImoveisDetalhesResumo', params: { id: $route.params.id } })" class="ma-0 white--text">
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
      <v-flex xs8>
        <v-container fluid class="py-2">      
          <v-layout row wrap>
            <v-flex xs12>
              <span class="subtitulo">Tarefas</span>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
    <template v-if="tarefas.length > 0">
      <v-card flat v-for="(item, index) in tarefas" :key="item.id">
        <v-layout row wrap class="pt-2">
          <v-flex xs12 sm10 offset-sm1 md8 offset-md2>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 sm6 class="tarefas-meta-coluna">
                  <v-icon>event_available</v-icon>
                  <TarefasSituacao :data="item.data" :realizada="item.realizada" :key="item.data">{{ item.data_formatada }}</TarefasSituacao>
                </v-flex>
                <v-flex xs12 sm6 class="tarefas-meta-coluna tarefas-meta-coluna-direita">
                  <TarefasSituacao :data="item.data" :realizada="item.realizada" :key="item.data"></TarefasSituacao>
                </v-flex>
                <v-flex xs12 class="mt-2">
                  {{ item.tipo }}
                </v-flex>
                <v-flex xs12>
                  <span class="grey--text">{{ taskUserName(item) }}</span>
                </v-flex>
              </v-layout>
            </v-card-text>
            <TarefasRealizar v-if="canCompleteTask(item)" :tarefaId="item.id" :imovelId="$route.params.id"></TarefasRealizar>
            <v-btn flat v-if="canEditTask(item)" class="text-xs-right primary--text" :to="({ name: 'TarefasEditar', params: { id: $route.params.id, tarefa: item.id } })">Editar</v-btn>
            <v-dialog v-model="dialogApagar" lazy max-width="520" v-if="$hasGranularPermission('tarefas', 'delete')">
              <v-btn flat class="error--text" slot="activator" @click.native="beforeApagar(item)">Apagar</v-btn>
              <v-card>
                <v-card-title>
                  <div class="headline">Tem certeza que deseja apagar?</div>
                </v-card-title>
                <v-card-text>Essa ação não poderá ser desfeita.</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn class="secondary--text" flat @click.native="dialogApagar = false">Descartar</v-btn>
                  <v-btn class="error--text" flat @click.native="onSubmitApagar()">Apagar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
      </v-card>
      <IrParaOTopo></IrParaOTopo>
    </template>
    <p class="text-xs-center mt-5 subheading" v-else>Nenhuma tarefa cadastrada.</p>
    <v-btn dark fab fixed bottom right class="secondary" :to="({ name: 'TarefasAdicionar', params: { id: imovelId } })" v-if="canAddTask">
      <v-icon>add</v-icon>
    </v-btn>
  </div>
</template>

<script>
  import axios from 'axios'
  import { apiURL } from '@/config'
  import { getAssignedUserId, getAssignedUserName } from '@/utils/assignedUser'
  import TarefasRealizar from './TarefasRealizar'
  import TarefasSituacao from './TarefasSituacao'
  import IrParaOTopo from '../Utils/IrParaOTopo'
  import HeadersDetalhesResumo from '../Imoveis/Headers/HeadersDetalhesResumo'

  export default {
    components: {
      IrParaOTopo,
      TarefasRealizar,
      TarefasSituacao,
      HeadersDetalhesResumo
    },
    data () {
      return {
        dialogApagar: false,
        imovelId: this.$route.params.id,
        itemApagar: {}
      }
    },
    mounted () {
      this.$primeUserRestrictions()
    },
    computed: {
      imovel () {
        return this.$store.getters['imoveis/detalhes']
      },
      currentUser () {
        if (!this.$auth || typeof this.$auth.user !== 'function') return null
        return this.$auth.user()
      },
      currentUserId () {
        const user = this.currentUser || {}
        return user.id || null
      },
      isLimitadoTarefas () {
        return this.$hasUserRestrictionFlag('limitado_tarefas')
      },
      tarefas () {
        const tarefas = this.$store.getters['imoveis/tarefas']
        if (!this.isLimitadoTarefas) {
          return tarefas
        }

        return tarefas.filter((item) => this.isTaskAssignedToCurrentUser(item))
      },
      canAddTask () {
        return !this.isLimitadoTarefas && this.$hasGranularPermission('tarefas', 'add')
      }
    },
    methods: {
      normalizeId (value) {
        if (value === null || typeof value === 'undefined' || value === '') return null
        return String(value)
      },
      taskUserId (item) {
        return getAssignedUserId(item)
      },
      taskUserName (item) {
        return getAssignedUserName(item)
      },
      isTaskAssignedToCurrentUser (item) {
        return this.normalizeId(this.taskUserId(item)) === this.normalizeId(this.currentUserId)
      },
      canCompleteTask (item) {
        return this.isTaskAssignedToCurrentUser(item) && !item.realizada
      },
      canEditTask (item) {
        if (!this.$hasGranularPermission('tarefas', 'edit')) {
          return false
        }

        if (!this.isLimitadoTarefas) {
          return true
        }

        return this.isTaskAssignedToCurrentUser(item)
      },
      descartar () {
        this.dialogApagar = false
      },
      beforeApagar (item) {
        this.itemApagar = item
      },
      onSubmitApagar () {
        axios.delete(`${apiURL}/tarefas/${this.itemApagar.id}`).then((response) => {
          this.$store.dispatch('imoveis/deleteTarefa', this.itemApagar)
          this.descartar()
          this.$store.dispatch('utils/hideLoading')
        }, () => {
          this.$store.dispatch('utils/showSnackbar', {
            text: 'Servidor indisponível. Tente novamente mais tarde.'
          })
          this.$store.dispatch('utils/hideLoading')
        })
      }
    }
  }
</script>

<style scoped>
@media (max-width: 599px) {
  .tarefas-meta-coluna {
    margin-bottom: 6px;
  }

  .tarefas-meta-coluna-direita {
    text-align: left;
  }
}

@media (min-width: 600px) {
  .tarefas-meta-coluna-direita {
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// TarefasLista.vue?0b2131b1